var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup17624(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17624",
    "data-name": "Group 17624",
    transform: "translate(-1051.682 -89.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17626",
    "data-name": "Group 17626"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8340",
    "data-name": "Rectangle 8340",
    width: 36,
    height: 36,
    transform: "translate(1051.682 89.5)",
    fill: "#2bc7b0",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17625",
    "data-name": "Group 17625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_146",
    "data-name": "Ellipse 146",
    transform: "translate(1056 94)",
    fill: "#2bc7b0",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8339",
    "data-name": "Rectangle 8339",
    width: 8,
    height: 5,
    transform: "translate(1073.318 100.074) rotate(-39)",
    fill: "#2bc7b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11547",
    "data-name": "Path 11547",
    d: "M441.8-1689.458l4-1.289,2.512,4.063a65.25,65.25,0,0,1,6.445-6.182,28.971,28.971,0,0,1,5.94-3.684,29.385,29.385,0,0,0-5.94,5.152c-2.779,3.195-6.6,10.656-6.6,10.656s-1.706-2.985-3.3-5.164A27.357,27.357,0,0,0,441.8-1689.458Z",
    transform: "translate(620 1794)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup17624);
export default __webpack_public_path__ + "static/media/Group 17624.6bbae5cdb2202fb23261f357b1a825a1.svg";
export { ForwardRef as ReactComponent };